import {
  FILE_SIZE_LIMITS,
  formatFileSize,
} from "@mg/schemas/src/commons/file-limits";
import { UploadSimple } from "@phosphor-icons/react";
import { Text } from "@radix-ui/themes";
import React from "react";

interface DragAndDropFileUploadProps {
  isDragging: boolean;
}

export const DragAndDropFileUpload: React.FC<DragAndDropFileUploadProps> = ({
  isDragging,
}) => {
  if (!isDragging) {
    return null;
  }
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 flex h-1/3 flex-col justify-end bg-gradient-to-t from-violet-violet7 to-transparent text-puntt-accent-10 backdrop-blur-sm transition-all"
      style={{
        maskImage: "linear-gradient(to top, black 50%, transparent 100%)",
        WebkitMaskImage: "linear-gradient(to top, black 50%, transparent 100%)",
      }}
      data-testid="drag-drop-upload-area"
    >
      <div className="m-6 flex flex-col items-center justify-end gap-6 rounded-xl border-2 border-dashed border-violet-violet8 p-6">
        <UploadSimple size={36} />
        <Text
          size="6"
          style={{
            textShadow:
              "0 0 5px rgba(111, 111, 223, 0.5), 0 0 10px rgba(111, 111, 223, 0.4), 0 0 15px rgba(111, 111, 223, 0.3)",
          }}
        >
          Drop Files or Folders to Upload
        </Text>
        <Text
          size="2"
          style={{
            textShadow:
              "0 0 5px rgba(111, 111, 223, 0.5), 0 0 10px rgba(111, 111, 223, 0.4), 0 0 15px rgba(111, 111, 223, 0.3)",
          }}
        >
          Max file size:{" "}
          {formatFileSize(FILE_SIZE_LIMITS.UPLOAD.MAX_SIZE_BYTES)}
        </Text>
      </div>
    </div>
  );
};
